(function () {
  const DATA = window.HauschildWineBrainAIData || [];

  function wbTrack(eventName, params = {}) {
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("event", eventName, params);
}

function wbGetSource() {
  const params = new URLSearchParams(window.location.search);
  return params.get("wb_source") || "direct";
}

  const STYLE_TARGETS = {
    fresh:   { ac: 4.2, bo: 1.7, fr: 3.2, oa: 0.2, mi: 2.8, ta: 0.6 },
    fruity:  { ac: 2.6, bo: 2.7, fr: 4.4, oa: 0.5, mi: 1.7, ta: 1.4 },
    mineral: { ac: 4.3, bo: 2.5, fr: 3.0, oa: 0.4, mi: 4.5, ta: 0.8 },
    power:   { ac: 2.8, bo: 4.5, fr: 4.0, oa: 3.0, mi: 2.0, ta: 3.3 },
    elegant: { ac: 3.5, bo: 3.0, fr: 3.4, oa: 1.4, mi: 3.2, ta: 2.0 }
  };

  const OCCASION_TERMS = {
    fish: ["fisch", "meeresfruchte", "sushi"],
    pasta: ["pasta", "pizza", "antipasti"],
    grill: ["grill", "bbq", "fleisch", "rind", "lamm", "wild"],
    veggie: ["gemuse", "salat", "vegetar", "spargel"],
    cheese: ["kase"],
    dessert: ["dessert", "kuchen", "schokolade"],
    aperitif: ["aperitif", "feier", "party"],
    gift: ["geschenk", "besonderer anlass"]
  };

  function norm(value) {
    return (value || "")
      .toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/ß/g, "ss")
      .toLowerCase()
      .trim();
  }

  function containsAny(haystack, needles) {
    const h = norm(haystack);
    return (needles || []).some(n => {
      const x = norm(n);
      return x && h.includes(x);
    });
  }

  function metadataText(p) {
    return [
      p.t, p.v, p.gr, p.co, p.rg, p.g, p.ar, p.st, p.fo, p.oc, p.rec
    ].join(" ");
  }

  function closeness(value, target) {
    return Math.max(0, 1 - Math.abs(Number(value || 0) - target) / 5);
  }

  function localPriceAllowed(p, f, tolerance) {
    const price = Number(p.p || 0);
    const tol = tolerance || 0;
    if (f.min_price != null && price < Number(f.min_price) - tol) return false;
    if (f.max_price != null && price > Number(f.max_price) + tol) return false;
    return true;
  }

  function scoreProduct(p, f) {
    if (!p || !p.h) return -9999;

    if (f.alcohol_free === true && Number(p.af) !== 1) return -9999;
    if (f.alcohol_free === false && Number(p.af) === 1) return -9999;
    if (f.bio_required === true && Number(p.bio) !== 1) return -9999;
    if (f.vegan_required === true && Number(p.ve) !== 1) return -9999;

    if (f.wine_type && f.wine_type !== "any" && p.ty !== f.wine_type) return -9999;

    if (containsAny(p.gr, f.excluded_grapes)) return -9999;
    if (containsAny([p.rg, p.co, p.t].join(" "), f.excluded_regions)) return -9999;

    if (!localPriceAllowed(p, f, 2.0)) return -9999;

    let score = 0;

    if (f.wine_type && f.wine_type !== "any") {
      score += 24;
    } else if (["port", "sweet", "orange"].includes(p.ty)) {
      score -= 11;
    } else if (p.ty === "other") {
      score -= 5;
    }

    if (f.sweetness === "dry") {
      if (Number(p.su) > 2.6) return -9999;
      score += closeness(p.su, 0.7) * 11;
      if (containsAny(p.g, ["trocken", "brut", "extra brut", "brut nature"])) score += 5;
    } else if (f.sweetness === "off_dry") {
      score += closeness(p.su, 2.0) * 13;
      if (containsAny(p.g, ["feinherb", "halbtrocken", "lieblich"])) score += 5;
    } else if (f.sweetness === "sweet") {
      if (Number(p.su) < 2.4 && p.ty !== "sweet") return -9999;
      score += closeness(p.su, 4.2) * 15;
      if (p.ty === "sweet") score += 8;
    }

    if (f.style && f.style !== "any" && STYLE_TARGETS[f.style]) {
      const target = STYLE_TARGETS[f.style];
      const weights = { ac: 4, bo: 4, fr: 4, oa: 2.5, mi: 3.5, ta: p.ty === "red" ? 2.5 : 1 };
      Object.keys(target).forEach(key => {
        score += closeness(p[key], target[key]) * weights[key];
      });

      const styleWords = {
        fresh: ["frisch", "leicht", "schlank", "knackig", "spritzig"],
        fruity: ["fruchtig", "saftig", "weich", "rund"],
        mineral: ["mineralisch", "prazise", "straff"],
        power: ["kraftig", "wurzig", "voll", "opulent"],
        elegant: ["elegant", "fein", "seidig"]
      };
      if (containsAny(p.st, styleWords[f.style] || [])) score += 7;
    }

    if ((f.preferred_grapes || []).length) {
      const hits = (f.preferred_grapes || []).filter(x => containsAny(p.gr, [x])).length;
      score += hits * 15;
      if (!hits) score -= 3;
    }

    if ((f.preferred_regions || []).length) {
      const regionText = [p.rg, p.co, p.t].join(" ");
      const hits = (f.preferred_regions || []).filter(x => containsAny(regionText, [x])).length;
      score += hits * 12;
      if (!hits) score -= 2;
    }

    const searchable = metadataText(p);

    if ((f.food_terms || []).length) {
      const hits = (f.food_terms || []).filter(x => containsAny([p.fo, searchable].join(" "), [x])).length;
      score += hits * 12;
      if (!hits) score -= 2;
    }

    if (f.occasion && f.occasion !== "any") {
      if (f.occasion === "casual") {
        score += Number(p.cp || 0) * 1.8;
        if (containsAny(p.oc, ["alltag", "terrasse"])) score += 7;
      } else if (f.occasion === "gift") {
        score += Number(p.gi || 0) * 3;
        if (containsAny(p.oc, OCCASION_TERMS.gift)) score += 8;
      } else {
        const terms = OCCASION_TERMS[f.occasion] || [];
        if (containsAny([p.fo, p.oc].join(" "), terms)) score += 9;
      }
    }

    if ((f.keywords || []).length) {
      const hits = (f.keywords || []).filter(x => containsAny(searchable, [x])).length;
      score += Math.min(hits, 5) * 3.5;
    }

    score += Number(p.cp || 0) * 0.55;
    score += Number(p.cf || 0) / 100 * 3;
    if (Number(p.hu || 0) === 1) score += 1.5;
    if (Number(p.q || 0) > 0) score += 2;

    return score;
  }

  async function fetchLiveProduct(handle) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    const response = await fetch(root + "products/" + encodeURIComponent(handle) + ".js", {
      credentials: "same-origin"
    });
    if (!response.ok) throw new Error("product_unavailable");
    return response.json();
  }

  function livePrice(product) {
    const available = (product.variants || []).filter(v => v.available);
    const prices = available.map(v => Number(v.price || 0));
    return (prices.length ? Math.min.apply(null, prices) : Number(product.price || 0)) / 100;
  }

  function livePriceAllowed(price, f) {
    if (f.min_price != null && price < Number(f.min_price)) return false;
    if (f.max_price != null && price > Number(f.max_price)) return false;
    return true;
  }

  function moneyEuros(euros) {
    return new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR"
    }).format(Number(euros || 0));
  }

  function escapeHtml(str) {
    return (str || "").toString().replace(/[&<>"']/g, m => ({
      "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;"
    })[m]);
  }

  function selectDiverse(items, count) {
    const picked = [];
    const vendors = new Set();

    for (const item of items) {
      const vendor = norm(item.meta.v);
      if (!vendor || !vendors.has(vendor)) {
        picked.push(item);
        if (vendor) vendors.add(vendor);
      }
      if (picked.length >= count) return picked;
    }

    for (const item of items) {
      if (!picked.some(x => x.meta.h === item.meta.h)) picked.push(item);
      if (picked.length >= count) break;
    }
    return picked;
  }

  async function rankAndValidate(filters) {
    const ranked = DATA
      .map(meta => ({ meta, score: scoreProduct(meta, filters) }))
      .filter(x => x.score > -9000)
      .sort((a, b) => b.score - a.score)
      .slice(0, 40);

    const live = await Promise.all(ranked.map(async item => {
      try {
        const product = await fetchLiveProduct(item.meta.h);
        if (!product || !product.available) return null;

      const tags = Array.isArray(product.tags)
       ? product.tags
       : String(product.tags || "").split(",");

      if (tags.some(tag => String(tag).trim().toLowerCase() === "ausschank")) {
       return null;
      }

      const price = livePrice(product);
if      (!livePriceAllowed(price, filters)) return null;
        if (!livePriceAllowed(price, filters)) return null;
        return { ...item, product, price };
      } catch {
        return null;
      }
    }));

    return selectDiverse(live.filter(Boolean).sort((a, b) => b.score - a.score), 3);
  }

  function productCard(item, label, buttonLabel) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    const url = root + "products/" + encodeURIComponent(item.meta.h);
    const p = item.product;
    const image = p.featured_image || (p.images && p.images[0]) || "";

    return `
      <article class="wbai-card">
        <a class="wbai-card__media" href="${url}">
          ${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(p.title)}" loading="lazy">` : ""}
        </a>
        <div class="wbai-card__body">
          <span class="wbai-card__match">${escapeHtml(label)}</span>
          ${item.meta.v ? `<div class="wbai-card__vendor">${escapeHtml(item.meta.v)}</div>` : ""}
          <h3 class="wbai-card__title"><a href="${url}">${escapeHtml(p.title)}</a></h3>
          <div class="wbai-card__price">${moneyEuros(item.price)}</div>
          ${item.meta.rec ? `<p class="wbai-card__why">${escapeHtml(item.meta.rec)}</p>` : ""}
          <a class="wbai-card__button" href="${url}">${escapeHtml(buttonLabel)}</a>
        </div>
      </article>`;
  }

  function init(root) {
    if (!root || root.dataset.wbaiReady === "true") return;
    root.dataset.wbaiReady = "true";

    const form = root.querySelector("[data-wbai-form]");
    const input = root.querySelector("[data-wbai-input]");
    const submit = root.querySelector("[data-wbai-submit]");
    const examples = root.querySelectorAll("[data-wbai-example]");
    const status = root.querySelector("[data-wbai-status]");
    const understood = root.querySelector("[data-wbai-understood]");
    const results = root.querySelector("[data-wbai-results]");
    const grid = root.querySelector("[data-wbai-grid]");
    const endpoint = root.dataset.endpoint;
    const labels = [
      root.dataset.rankOne || "Unser stärkster Treffer",
      root.dataset.rankTwo || "Passt sehr gut",
      root.dataset.rankThree || "Auch spannend"
    ];
    const buttonLabel = root.dataset.productButton || "Zum Wein";
    let lastFilters = {};

    grid.addEventListener("click", function (event) {
  const link = event.target.closest("a[href*='/products/']");
  if (!link || !grid.contains(link)) return;

  const card = link.closest(".wbai-card");
  const cards = Array.from(grid.querySelectorAll(".wbai-card"));
  const rank = card ? cards.indexOf(card) + 1 : 0;

  const url = new URL(link.href, window.location.origin);
  const productHandle = decodeURIComponent(
    (url.pathname.split("/products/")[1] || "").split("/")[0]
  );

  wbTrack("winebrain_ai_product_click", {
    product_handle: productHandle,
    rank: rank,
    wine_type: lastFilters.wine_type || "any",
    sweetness: lastFilters.sweetness || "any",
    style: lastFilters.style || "any",
    occasion: lastFilters.occasion || "any",
    min_price: lastFilters.min_price ?? "",
    max_price: lastFilters.max_price ?? "",
    winebrain_source: wbGetSource(),
    page_path: window.location.pathname
  });
});

    examples.forEach(button => {
      button.addEventListener("click", function () {
        input.value = button.dataset.wbaiExample || "";
        input.focus();
      });
    });

    form.addEventListener("submit", async function (event) {
      event.preventDefault();
      const query = input.value.trim();
      if (query.length < 3) return;

      if (!endpoint) {
        status.textContent = "Der KI-Endpunkt ist im Theme-Editor noch nicht hinterlegt.";
        return;
      }

      wbTrack("winebrain_ai_search", {
        winebrain_source: wbGetSource(),
  page_path: window.location.pathname
});

      submit.disabled = true;
      const original = submit.textContent;
      submit.textContent = root.dataset.loadingLabel || "Wine Brain denkt …";
      status.textContent = "";
      understood.textContent = "";
      results.hidden = true;
      grid.innerHTML = "";

      try {
        const response = await fetch(endpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ query })
        });

        const parsed = await response.json();
        if (!response.ok || !parsed.filters) throw new Error("parse_failed");

        lastFilters = parsed.filters;

        understood.textContent = parsed.filters.understood_as
          ? "Verstanden als: " + parsed.filters.understood_as
          : "";

        const matches = await rankAndValidate(parsed.filters);

        if (!matches.length) {
          status.textContent = "Dazu finde ich gerade keinen verfügbaren Treffer. Formuliere die Suche etwas offener.";
          results.hidden = false;
          return;
        }

        grid.innerHTML = matches.map((item, i) =>
          productCard(item, labels[i] || labels[2], buttonLabel)
        ).join("");

        results.hidden = false;

        const resultHandles = matches.map(x => x.meta.h);

wbTrack("winebrain_ai_results", {
  wine_type: lastFilters.wine_type || "any",
  sweetness: lastFilters.sweetness || "any",
  style: lastFilters.style || "any",
  occasion: lastFilters.occasion || "any",
  min_price: lastFilters.min_price ?? "",
  max_price: lastFilters.max_price ?? "",
  winebrain_source: wbGetSource(),
  result_count: resultHandles.length,
  result_1: (resultHandles[0] || "").slice(0, 80),
  result_2: (resultHandles[1] || "").slice(0, 80),
  result_3: (resultHandles[2] || "").slice(0, 80),
  page_path: window.location.pathname
});
      } catch (error) {
        status.textContent = "Da hat gerade etwas gehakt. Bitte versuch es noch einmal.";
        results.hidden = false;
      } finally {
        submit.disabled = false;
        submit.textContent = original;
      }
    });
  }

  function boot() {
    document.querySelectorAll("[data-winebrain-ai-search]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", event => {
    const root = event.target.querySelector("[data-winebrain-ai-search]");
    if (root) init(root);
  });
})();